import React from "react";
import {
  makeStyles,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { text } from "../../utils/Multilanguage";

const styles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: "relative",
    flex: 1,
    padding: 16,
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "1px solid",
  },
}));

export default function DialogMultipleSession(props) {
  const { open, handleOk } = props;
  const classes = styles();

  return (
    <Dialog
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      open={open}
      fullWidth={true}
      maxWidth='xl'
      id='DialogMultiple'
      disableBackdropClick={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        style={{ backgroundColor: "#fafafa" }}
      >
        {text("Warning")}
      </DialogTitle>
      <DialogContent>
        <div className={classes.imgContainer} id='container'>
          <h6>{text("Multiple open sessions have been detected")}</h6>
          <br />
        </div>
      </DialogContent>
      <DialogActions style={{ color: "white" }}>
        <Button
          variant='contained'
          style={{ background: "#fafafa" }}
          onClick={handleOk}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
